



































import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import FormField from "@/lib/components/FormField.vue";
import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import { Resource } from "@/modules/account/resource";

import FactorySettings from "../factory-settings.model";
import FactoryStore from "../store";

@Component({
  components: {
    FormErrors,
    FormField,
    LoadingSpinner,
    SubmitButton,
  },
})
export default class FactoryEarlyArtworkAccessForm extends mixins(
  GeneralFormMixin
) {
  @Prop({ required: true })
  public readonly factoryId!: string;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  public isEarlyArtworkAccessEnabled?: boolean;

  private fIsLoading = false;
  private fFactoryDataStore: FactoryStore;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get canManage(): boolean {
    const user = this.fUserProvider.getUser();

    return !!user && user.hasPermissionForResource(Resource.FACTORY_MANAGE);
  }

  get canView(): boolean {
    const user = this.fUserProvider.getUser();

    return (
      !!user &&
      (this.canManage || user.hasPermissionForResource(Resource.FACTORY_VIEW))
    );
  }

  constructor() {
    super();

    this.fFactoryDataStore = getModule(FactoryStore, dataStore);
  }

  protected async performSubmit(): Promise<void> {
    if (this.isEarlyArtworkAccessEnabled === undefined) {
      return;
    }

    const saved = await this.fFactoryDataStore.saveFactorySettings(
      new FactorySettings(this.factoryId, this.isEarlyArtworkAccessEnabled)
    );

    this.isEarlyArtworkAccessEnabled = saved.isEarlyArtworkAccessEnabled;
  }

  @Watch("factoryId", { immediate: true })
  private async load(): Promise<void> {
    this.submitErrors = [];

    if (!this.canView || !this.factoryId) {
      return;
    }

    this.fIsLoading = true;

    try {
      const settings = await this.fFactoryDataStore.loadFactorySettings({
        factoryId: this.factoryId,
        useCache: false,
      });

      if (settings) {
        this.isEarlyArtworkAccessEnabled = settings.isEarlyArtworkAccessEnabled;
      }
    } catch (error) {
      this.submitErrors = this.fErrorConverterService.describeError(error);
    } finally {
      this.fIsLoading = false;
    }
  }
}
